import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class PlatoService {
  platos;
  headersPlato: any[] = [
    { field: 'descripcion', header: 'Menú' }
  ];
  constructor(private httpService: HttpService) { }

  getPlatos() {
    return this.httpService.get('plato');
  }
  altaPlato(plato) {
    return this.httpService.post('plato', plato);
  }
  getHeadersPlatos() {
    return this.headersPlato;
  }
  updatePlato(plato) {
    return this.httpService.put('plato/' + plato.id, plato);
  }
  setPlatos(value: any) {
    this.platos = value;
  }
  getPlatosService() {
    return this.platos;
  }
  modPlatos(platos) {
    let platosHabilitados = new Array();
    let otroPedido;
    platos.forEach(plato => {
      if (plato.habilitado && !plato.platoDia && plato.descripcion != 'Otro pedido') {
        platosHabilitados.push(plato);
      }
      if (plato.habilitado && plato.platoDia && plato.descripcion != 'Otro pedido') {
        platosHabilitados.unshift(plato);
      }
      if (plato.descripcion == 'Otro pedido' && plato.habilitado) {
        otroPedido = plato;
      }
    });
    if (!isNullOrUndefined(otroPedido)) {
      platosHabilitados.push(otroPedido);
    }
    if (platosHabilitados.length > 0) {
      return platosHabilitados;
    }
  }
}